<ng-container *ngIf="leadStats$ | async as statsData">
  <!-- Lead pipeline KPIs -->
  <div class="grid mb-4">
    <div class="col-6 md:col-2">
      <share-stat-card
        icon="pi pi-shopping-cart"
        label="New Leads"
        color="blue"
        [value]="statsData.new"
      ></share-stat-card>
    </div>
    <div class="col-6 md:col-2">
      <share-stat-card
        icon="pi pi-shopping-cart"
        label="Qualified"
        color="orange"
        [value]="statsData.qualified"
      ></share-stat-card>
    </div>
    <div class="col-6 md:col-2">
      <share-stat-card
        icon="pi pi-users"
        label="Opportunity"
        color="teal"
        [value]="statsData.opportunity"
      ></share-stat-card>
    </div>
    <div class="col-6 md:col-2">
      <share-stat-card
        icon="pi pi-check-circle"
        label="Closed-Win"
        color="brand"
        [value]="statsData['closed-win']"
      ></share-stat-card>
    </div>
    <div class="col-6 md:col-2">
      <share-stat-card
        icon="pi pi-times-circle"
        label="Closed-Loss"
        color="red"
        [value]="statsData['closed-loss']"
      ></share-stat-card>
    </div>
  </div>

  <ng-container *ngIf="actionStats$ | async as actionStatsData">
    <share-section-card title="Daily Statistics" icon="pi pi-chart-bar" shadow="shadow-1">
      <p-chart type="bar" height="20vh" [data]="actionStatsData.chart"></p-chart>
    </share-section-card>

    <share-section-card title="Individual Daily Statistics" icon="pi pi-list" shadow="shadow-1">
      <ul class="list-none p-0 m-0" style="max-height: 40vh; overflow-y: auto">
        <li
          class="py-3 border-bottom-1 surface-border flex flex-column md:flex-row md:align-items-start md:justify-content-between"
          *ngFor="let dayStats of actionStatsData.stats | nestedKeyvalue"
        >
          <div class="flex flex-row align-items-center mr-0 lg:mr-5">
            <div class="flex-grow-1">
              <span class="text-500 font-medium">{{ dayStats.key }}</span>
            </div>
            <div
              class="surface-100 border-round p-4 mx-4 flex-grow-0 w-full"
              *ngFor="let agentStats of dayStats.value | nestedKeyvalue"
            >
              <span class="text-900 font-semibold text-blue-700">
                {{ agentStats.key | uppercase }}
              </span>
              <ul
                class="mt-1 list-none p-0 mx-0"
                *ngFor="let actionStats of agentStats.value | nestedKeyvalue"
              >
                <li class="flex align-items-center">
                  <span
                    style="width: 1rem; height: 1rem"
                    class="border-round bg-indigo-500 mr-3 flex-shrink-0"
                  ></span>
                  <span class="font-medium text-900">{{ actionStats.key | uppercase }}</span>
                  <span class="text-600 font-medium ml-auto">{{ actionStats.value }}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </share-section-card>
  </ng-container>
</ng-container>
